"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.IListItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _TypographyVariantTypes = require("../RichText/TypographyVariantTypes");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _getIcon = require("../utils/getIcon");
var _excluded = ["ListComponent", "item", "textSize", "iconSize"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var IListItem = exports.IListItem = {
  sys: _propTypes.default.shape({
    id: _propTypes.default.string,
    type: _propTypes.default.string,
    createdAt: _propTypes.default.string,
    updatedAt: _propTypes.default.string,
    locale: _propTypes.default.string,
    contentType: _propTypes.default.object
  })
};
var ListItem = _ref => {
  var _item$fields3, _item$fields4, _item$fields5, _item$fields6;
  var {
      ListComponent,
      item,
      textSize,
      iconSize
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var IconComponent = (0, _react.useMemo)(() => {
    var _item$fields, _item$fields2;
    return (_item$fields = item.fields) !== null && _item$fields !== void 0 && _item$fields.iconName ? (0, _getIcon.getIcon)((_item$fields2 = item.fields) === null || _item$fields2 === void 0 ? void 0 : _item$fields2.iconName) : undefined;
  }, [(_item$fields3 = item.fields) === null || _item$fields3 === void 0 ? void 0 : _item$fields3.iconName]);
  var iconProps = !!IconComponent ? {
    icon: IconComponent,
    iconColor: _TypographyVariantTypes.iconColors[(_item$fields4 = item.fields) === null || _item$fields4 === void 0 ? void 0 : _item$fields4.iconColor],
    iconSize: iconSize
  } : null;
  return /*#__PURE__*/_react.default.createElement(ListComponent.Item, _extends({}, rest, {
    title: (_item$fields5 = item.fields) === null || _item$fields5 === void 0 ? void 0 : _item$fields5.heading
  }, iconProps), /*#__PURE__*/_react.default.createElement(_componentsWeb.Paragraph, {
    variant: {
      size: textSize
    },
    tokens: {
      marginTop: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (_item$fields6 = item.fields) === null || _item$fields6 === void 0 ? void 0 : _item$fields6.text)));
};
ListItem.propTypes = {
  ListComponent: _propTypes.default.element,
  item: _propTypes.default.shape(IListItem),
  iconSize: _propTypes.default.number,
  textSize: _propTypes.default.oneOf(_TypographyVariantTypes.ListSize)
};
var _default = exports.default = ListItem;